import store from "../../../store";
import moment from "moment";
import { DateType, dateTypes } from "@core/helpers/datepicker";

export const serializeDate = (date: Date, dateType: DateType = "dateTime"): string => moment(date)
  .format(`${ dateTypes[dateType] }${ store.getters.timezone.offset }`);
